import React from "react";
import ReactDOM from "react-dom";
import Root from "./containers/Root";
import configureStore from "./store/configureStore";
import "babel-polyfill";

const store = configureStore();

ReactDOM.render(<Root store={store} />, document.getElementById("root"));

export default store;



// WEBPACK FOOTER //
// ./src/index.js